// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"7cf64b2d","446":"e9507950","488":"9b8e43fe","530":"e3f32e3e","661":"01cb58fc","684":"634b6764","719":"75c660ee","735":"e85bdcf8","833":"d7feb290"}[chunkId] + ".chunk.js";
};